import script from "./Stazioni.vue?vue&type=script&setup=true&lang=js"
export * from "./Stazioni.vue?vue&type=script&setup=true&lang=js"

import "./Stazioni.vue?vue&type=style&index=0&id=ed31293c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed31293c"]])

export default __exports__